import { Activity, Hash, Radio, Server, Terminal, Cpu } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testid, tone = "text-slate-100" }) => (
  <div className="card p-4 flex items-center gap-3 fade-up" data-testid={testid}>
    <div className="h-9 w-9 rounded-md bg-slate-800/80 grid place-items-center shrink-0">
      <Icon className="h-4 w-4 text-emerald-400" />
    </div>
    <div className="min-w-0">
      <div className="caption">{label}</div>
      <div className={`font-heading font-bold text-lg truncate ${tone}`}>{value}</div>
    </div>
  </div>
);

export default function StatusStrip({ status }) {
  const lv = status?.lavalink || {};
  return (
    <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="status-strip">
      <Stat icon={Activity} label="Bot" value={status?.online ? status.name : "Offline"} testid="stat-bot-name"
        tone={status?.online ? "text-emerald-300" : "text-red-300"} />
      <Stat icon={Radio} label="Lavalink" value={lv.online ? `v${lv.version}` : "Brak"} testid="stat-lavalink"
        tone={lv.online ? "text-emerald-300" : "text-red-300"} />
      <Stat icon={Cpu} label="Ping" value={status?.online ? `${status.latency_ms} ms` : "—"} testid="stat-ping" />
      <Stat icon={Server} label="Serwery" value={status?.guild_count ?? "—"} testid="stat-guilds" />
      <Stat icon={Hash} label="Kanały głosowe" value={status?.voice_connections ?? lv.players ?? 0} testid="stat-voice" />
      <Stat icon={Terminal} label="Prefiks" value={status?.prefix || "!"} testid="stat-prefix" tone="text-indigo-300 font-mono" />
    </section>
  );
}
